import type { LucideIcon } from 'lucide-react';

/** Row of purchase reassurances, each an icon, a short claim and one line of detail. */
export function TrustStrip({ items }: { items: readonly { icon: LucideIcon; title: string; body: string }[] }) {
  return (
    <ul className="grid gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <li key={item.title} className="flex items-start gap-3">
            <span className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <Icon className="size-4" aria-hidden="true" />
            </span>
            <span>
              <span className="block text-sm font-semibold text-foreground">{item.title}</span>
              <span className="mt-0.5 block text-sm leading-6 text-muted-foreground">{item.body}</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
